import React, { useId } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../lib/auth-context";
import { SUPPORTED_LOCALES, isLocale } from "../i18n";
import { cn } from "../lib/utils";

/** Language choice, applied instantly and saved on the account when signed in. */
export function LanguageSwitcher({ className }: { className?: string }) {
  const { t, i18n } = useTranslation();
  const { changeLocale } = useAuth();
  const id = useId();

  return (
    <div className={cn("flex items-center justify-between gap-3", className)}>
      <label htmlFor={id} className="text-sm text-muted-foreground">
        {t("language.label")}
      </label>
      <select
        id={id}
        value={i18n.resolvedLanguage}
        onChange={(e) => isLocale(e.target.value) && changeLocale(e.target.value)}
        className="rounded-md border border-border bg-background px-2 py-1 text-sm"
      >
        {SUPPORTED_LOCALES.map((locale) => (
          <option key={locale} value={locale}>
            {t(`language.${locale}`)}
          </option>
        ))}
      </select>
    </div>
  );
}
